module.exports = __webpack_public_path__ + "static/apple-icon-152x152-2293f8a772fa1bcdd10643660208bf72.png";